import React, { Component } from "react";

class NotAllowed extends Component {
  render() {
    return (
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404">
            <h1>403</h1>
          </div>
          <h2>We are sorry!</h2>
          <p>
            The page you are trying to access has restricted access. Please
            refer to your system administrator.
          </p>
          <a href="/">Back To Homepage</a>
        </div>
      </div>
    );
  }
}

export default NotAllowed;
